module.exports = __webpack_public_path__ + "img/finance_professional.70dd4f33.svg";